/**
 * User: ronald
 * Date: 5/8/14
 * Time: 3:46 PM
 */

'use strict';

/**
 * @module {object} verticals
 * @property {string} VERTICAL_KEY          "VERTICAL_"
 * @property {string} PREFIX_KEY            "PREFIX_"
 * @property {string} VERTICAL_FURNITURE    "furniture"
 * @property {string} VERTICAL_FASHION      "fashion"
 * @property {string} VERTICAL_JEWELRY      "jewelry"
 * @property {string} VERTICAL_ART          "art"
 * @property {string} PREFIX_FURNITURE      "f_"
 * @property {string} PREFIX_FASHION        "v_"
 * @property {string} PREFIX_JEWELRY        "j_"
 * @property {string} PREFIX_ART            "a_"
 */
var verticals = {
    VERTICAL_KEY: 'VERTICAL_',
    PREFIX_KEY: 'PREFIX_',
    VERTICAL_FURNITURE: 'furniture',
    VERTICAL_FASHION: 'fashion',
    VERTICAL_JEWELRY: 'jewelry',
    VERTICAL_ART: 'art',
    PREFIX_FURNITURE: 'f_',
    PREFIX_FASHION: 'v_',
    PREFIX_JEWELRY: 'j_',
    PREFIX_ART: 'a_',
    DISPLAY_FURNITURE: 'Furniture',
    DISPLAY_FASHION: 'Fashion',
    DISPLAY_JEWELRY: 'Jewelry',
    DISPLAY_JEWELRY_WATCHES: 'Jewelry &amp; Watches',
    DISPLAY_ART: 'Fine Art'
};

/**
 * done to maintain support for the Category class
 * it was originally using `letterToVertical` method
 * and the signature was expecting the pk sans underscore
 * as its lone argument
 */
verticals.f = verticals.VERTICAL_FURNITURE;
verticals.v = verticals.VERTICAL_FASHION;
verticals.j = verticals.VERTICAL_JEWELRY;
verticals.a = verticals.VERTICAL_ART;
verticals.furniture = verticals.f;
verticals.fashion = verticals.v;
verticals.jewelry = verticals.j;
verticals.art = verticals.a;

/**
 * Verticals Prefix Map referenced on the Item Model used on the image upload page
 * Maps each prefix to its vertical and each vertical to its prefix
 * @type {{f_: string, a_: string, j_: string, v_: string, furniture: string, art: string, jewelry: string, fashion: string}}
 */
verticals.prefixMap = {};
verticals.prefixMap[verticals.PREFIX_FURNITURE] = verticals.VERTICAL_FURNITURE;
verticals.prefixMap[verticals.PREFIX_ART] = verticals.VERTICAL_ART;
verticals.prefixMap[verticals.PREFIX_JEWELRY] = verticals.VERTICAL_JEWELRY;
verticals.prefixMap[verticals.PREFIX_FASHION] = verticals.VERTICAL_FASHION;
verticals.prefixMap[verticals.VERTICAL_FURNITURE] = verticals.PREFIX_FURNITURE;
verticals.prefixMap[verticals.VERTICAL_ART] = verticals.PREFIX_ART;
verticals.prefixMap[verticals.VERTICAL_JEWELRY] = verticals.PREFIX_JEWELRY;
verticals.prefixMap[verticals.VERTICAL_FASHION] = verticals.PREFIX_FASHION;

/**
 * Verticals Display Name Map referenced in the ContactSupport helper
 * Maps each vertical to it's display name
 */
verticals.displayMap = {};
verticals.displayMap[verticals.VERTICAL_FURNITURE] = verticals.DISPLAY_FURNITURE;
verticals.displayMap[verticals.VERTICAL_ART] = verticals.DISPLAY_ART;
verticals.displayMap[verticals.VERTICAL_JEWELRY] = verticals.DISPLAY_JEWELRY;
verticals.displayMap[verticals.VERTICAL_FASHION] = verticals.DISPLAY_FASHION;

/**
 * Do some action for each vertical. Callback will be called with the following arguments :
 *      - vertical <string> - the vertical name
 *      - data <object> - a data object with info about the vertical containing :
 *          - name
 *          - pk
 *          - prefix
 * @param callback
 * @param context
 */
verticals.each = function (callback, context) {
    var self = this;
    var arr = [this.VERTICAL_FURNITURE, this.VERTICAL_FASHION, this.VERTICAL_JEWELRY, this.VERTICAL_ART];
    arr.forEach(function (vertical) {
        var caller = context ? context : null;
        var pk = self.getPrefix(vertical);
        callback.call(caller, vertical, pk);
    });
};

/**
 * @private
 * @param {string} keyPrefix The key prefix to use: VERTICAL_KEY or PREFIX_KEY
 * @param {string} vertical The vertical to use
 * @returns {string|null}
 */
function getWithKey(keyPrefix, vertical) {
    var ret;
    var prefix;
    if (keyPrefix && vertical) {
        prefix = verticals[keyPrefix] + vertical.toUpperCase();
        ret = verticals[prefix];
    }
    return ret || null;
}

/**
 * Get the vertical with a pk/prefix (ie. f_)
 * @private
 * @param value
 * @returns {string|null}
 */
function getWithPk(value) {
    if (verticals.testForPk(value)) {
        value = value[0];
    }
    return verticals[value] || null;
}

/**
 * Make sure an actual vertical is getting returned
 * @private
 * @param {string} vertical
 * @returns {string|null}
 */
function getVerticalValue(vertical) {
    var ret;
    if (vertical) {
        ret = getWithKey('VERTICAL_KEY', vertical);
    }
    return ret || null;
}

/**
 * @private
 * @param {string} vertical
 * @returns {string|null}
 */
function getPrefixValue(vertical) {
    var ret;
    if (vertical) {
        ret = getWithKey('PREFIX_KEY', vertical);
    }
    return ret || null;
}

/**
 * Is the value a pk/prefix?
 * @private
 * @param {string} value
 * @returns {boolean}
 */
verticals.testForPk = function (value) {
    return (/^[afjv]_\d*$/).test(value);
};

/**
 * This is due to the fact the Category model is was using the now
 * deleted `verticalToPrefix` method that was in this helper file.
 * In order to maintain compatibility with that class, this method
 * was created
 * @memberof module:verticals
 * @param {string} value The vertical
 * @returns {string|null}
 */
verticals.getPrefix = function (value) {
    var prefix = getPrefixValue(value);
    var vertical;
    if (!prefix && value) {
        vertical = getVerticalValue(value);
        prefix = getPrefixValue(vertical);
    }
    return prefix || null;
};

/**
 * This is due to the fact the Category model is was using the now
 * deleted `letterToVertical` method that was in this helper file.
 * In order to maintain compatibility with that class, this method
 * was created
 * @memberof module:verticals
 * @param {string} value Value to convert to a valid vertical
 * @returns {string|null}
 */
verticals.getVertical = function (value) {
    return getVerticalValue(value) ||
        getPrefixValue(value) ||
        getWithPk(value) ||
        // if no vertical is found, it shouldn't return a truthy value
        null;
};

/**
 * Gets the display name of the vertical given the vertical name
 * @param value
 * @returns {*|null}
 */
verticals.getDisplayFromVertical = function (value) {
    return verticals.displayMap[value] || null;
};

/**
 * Gets the display name of the vertical given the vertical prefix
 * @param value
 * @returns {*|null}
 */
verticals.getDisplayFromPrefix = function (value) {
    return verticals.displayMap[getWithPk(value)] || null;
};


// end "legacy" support
module.exports = Object.freeze ? Object.freeze(verticals) : verticals;



//////////////////
// WEBPACK FOOTER
// ./~/dibs-vertical-helpers/index.js
// module id = 373
// module chunks = 62